import { Disclaimer } from './Disclaimer.container';

export default Disclaimer;
